import { IonSkeletonText } from "@ionic/react";
import { SwiperSlide } from "swiper/react";

import styles from "@components/explore/Explore.module.css";
import CardSlides from "@components/layout/CardSlides";
import loaderStyles from "@components/loaders/LoaderStyles.module.css";
import { FocusAreaEnum } from "@typing/Generated";

type SectionProps = {
  focusArea?: FocusAreaEnum;
};

const Section = ({ focusArea }: SectionProps) => (
  <div className={`${styles.articleSection} ${focusArea ? styles.focusAreaSpacing : ""}`}>
    {focusArea && (
      <div className={styles.articlesHeader}>
        <div className={loaderStyles.emptyHeader} />
      </div>
    )}

    <CardSlides itemCount={3}>
      <SwiperSlide>
        <IonSkeletonText animated className={loaderStyles.skeletonArticleCard} />
      </SwiperSlide>
      <SwiperSlide>
        <IonSkeletonText animated className={loaderStyles.skeletonArticleCard} />
      </SwiperSlide>
      <SwiperSlide>
        <IonSkeletonText animated className={loaderStyles.skeletonArticleCard} />
      </SwiperSlide>
    </CardSlides>
  </div>
);

const ExploreArticlesLoader = () => (
  <div>
    <Section />
    <Section focusArea={FocusAreaEnum.wellbeing} />
    <Section focusArea={FocusAreaEnum.medical} />
  </div>
);

export default ExploreArticlesLoader;
